import Component from "@glimmer/component";
import moment from "moment";

function addZero(num) {
  return num > 9 ? num : `0${num}`;
}

export default class FrlClock extends Component {
  get formattedTime() {
    const duration = moment.duration((this.args.wait || 0) * 1000);

    return [Math.floor(duration.asHours()), duration.minutes(), duration.seconds()]
      .map(addZero)
      .join(":");
  }

  <template>
    <div class="frl-clock">{{this.formattedTime}}</div>
  </template>
}
